import { Dialog, DialogHeader, DialogBody, DialogFooter, Button } from '@material-tailwind/react'

export function ConfirmCancelModal({ open, busy, target, onClose, onConfirm, fmt }) {
  const vd = target?.visitor_data || {}
  const company = vd.origin_company || vd.company_name || null

  return (
    <Dialog open={open} handler={onClose} size="sm">
      <DialogHeader>Confirmar cancelación</DialogHeader>
      <DialogBody divider>
        {target && (
          <div className="space-y-1 text-sm">
            <p>¿Seguro que deseas <span className="font-semibold">cancelar</span> esta invitación?</p>
            <p className="mt-2"><span className="font-medium">Invitado:</span> {vd.name || '—'}</p>
            {vd.document_number && <p><span className="font-medium">Doc:</span> {vd.document_number}</p>}
            {company && <p><span className="font-medium">Empresa:</span> {company}</p>}
            <p><span className="font-medium">Dependencia:</span> {target.office_name}</p>
            <p><span className="font-medium">Ventana:</span> {fmt(target.starts_at)} – {fmt(target.ends_at)}</p>
          </div>
        )}
      </DialogBody>
      <DialogFooter>
        <Button variant="text" onClick={onClose} disabled={busy} className="mr-2">
          Volver
        </Button>
        <Button color="red" onClick={onConfirm} loading={busy}>
          Cancelar invitación
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
